// 评价档位表情图标映射：题库 JSON options[].emoji 字段存图标 key，此处负责 key → 图片资源
// 约定 key 命名 emoji_N，N 对应档位 score（1-5）；字段值为非 key 文本（如 unicode emoji）时由组件回退为文本渲染
export const EMOJI_ICON_KEY_PREFIX = 'emoji_';

const emojiIconMap = {
    emoji_1: require('@/assets/images/simulation/evaluationTool/emoji/emoji_1.webp'),
    emoji_2: require('@/assets/images/simulation/evaluationTool/emoji/emoji_2.webp'),
    emoji_3: require('@/assets/images/simulation/evaluationTool/emoji/emoji_3.webp'),
    emoji_4: require('@/assets/images/simulation/evaluationTool/emoji/emoji_4.webp'),
    emoji_5: require('@/assets/images/simulation/evaluationTool/emoji/emoji_5.webp')
};

export default emojiIconMap;
